export default {
	'add-message': 'Add Message',
	'edit-message': 'Edit Message',
}